@use '@hevoio/hevo-ui-toolkit/styles/variables' as hevo-toolkit-variables;

.headerWrapper {
  margin-bottom:  hevo-toolkit-variables.$spacer * 1.25 !important;

  .linkHolder {
    display: flex;
    align-items: center;
    white-space: pre;
    margin-top:  hevo-toolkit-variables.$spacer * 0.25 !important;
  }
}
